import Axios, { AxiosResponse } from 'axios'
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig'
import AxiosPostProcessor from './AxiosPostProcessor'
import { FeedbackRequest, FeedbackView } from './Feedback'
import RecaptchaProtectedResponse from './RecaptchaProtectedResponse'

export class FeedbackServiceStatic {
    submit(request: FeedbackRequest): Promise<AxiosResponse<RecaptchaProtectedResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/feedback`
        return AxiosPostProcessor.postProcess(Axios.post(url, request, AxiosDefaultRequestConfig.merge({})))
    }

    get(id: string): Promise<AxiosResponse<FeedbackView>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/admin/feedback/${encodeURIComponent(id)}`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({})))
    }

    delete(id: string): Promise<AxiosResponse<void>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/admin/feedback/${encodeURIComponent(id)}`
        return AxiosPostProcessor.postProcess(Axios.delete(url, AxiosDefaultRequestConfig.merge({})))
    }
}

const FeedbackService = new FeedbackServiceStatic()
export default FeedbackService
